export const isLoggedIn = () => window.localStorage.getItem('satellizer_token')

export const onLogout = () => {
  const mail=window.localStorage.getItem('userEmail')
  window.localStorage.clear();
  window.localStorage.setItem('userEmail',mail)

}


